<script>
import { computed, onMounted, ref, toRefs } from 'vue'
import { onClickOutside } from '@vueuse/core'

export default {
  props: {
    options: { type: Array, default: () => [] }
  },
  setup(props) {
    const { options } = toRefs(props)
    const dropdown = ref(null)
    const isOpen = ref(false)

    onMounted(() => {
      onClickOutside(dropdown, () => {
        isOpen.value = false
      })
    })

    const numberOfRows = computed(() => {
      let param = true
      options.value.forEach((string) =>
        string.length > 50 ? (param = false) : ''
      )
      if (param) return parseInt(options.value.length / 2, 10) + 1
      return options.value.length
    })
    return { dropdown, isOpen, numberOfRows }
  }
}
</script>

<template>
  <div class="mt-auto relative" ref="dropdown">
    <r-button
      class="w-34"
      textColor="dark-gray"
      defaultColor="nude"
      secondColor="mediator"
      size="lg"
      @r:click="isOpen = !isOpen"
      ><slot />
    </r-button>
    <div
      class="absolute text-black shadow rounded-lg top-14 -left-8 xl:left-0 bg-white py-5 px-4 grid gap-4 gap-y-2 auto-cols-max z-50 grid-cols-1 xl:grid-cols-2 min-w-max"
      :class="[isOpen ? 'block' : 'hidden']"
    >
      <p
        v-for="option in options"
        :key="option"
        class="relative text-base text-dark-gray font-sans whitespace-nowrap"
      >
        {{ option }}
      </p>
    </div>
  </div>
</template>
